import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _taggedTemplateLiteral from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3;
import { Ge as l, hi as h, T as b, bo as u, M as m, fi as p } from "./abstract-base-8edf0a84-e11d45a3.js";
import { e as y } from "./state-b4c9cc73-ee633f6c.js";
import { N as f, C as v } from "./analytics-97672af0-7197eb6b.js";
import { r as g } from "./lifecycle-decorators-ecc4e836-92da4b80.js";
import { A as x } from "./query-assigned-ba663908-228b08f4.js";
import "./query-24926cff-3eb94bfb.js";
var d = {
    beaconTagName: "beacon-country-selector"
  },
  C = l(_templateObject || (_templateObject = _taggedTemplateLiteral(["[beacon-tag-name=beacon-country-selector] [slot=title]{font:var(--beacon-system-font-weight-bold, var(--beacon-font-weight-bold)) var(--beacon-system-font-size-serif-headline-50, var(--beacon-headline-font-size-50)/var(--beacon-headline-font-line-height-module-50) var(--beacon-font-family-default))}[beacon-tag-name=beacon-country-selector] [slot=title] :is(h1,h2,h3,h4,h5,h6){font:var(--beacon-system-font-weight-bold, var(--beacon-font-weight-bold)) var(--beacon-system-font-size-serif-headline-50, var(--beacon-headline-font-size-50)/var(--beacon-headline-font-line-height-module-50) var(--beacon-font-family-default))}\n"]))),
  S = l(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([":host{display:grid;gap:var(--beacon-system-space-micro-jumbo, var(--beacon-space-micro-jumbo));inline-size:100%}@media (min-width: 960px){:host{gap:var(--beacon-reference-space-9, calc(2 * var(--beacon-unit-base)))}}.current-selection{display:grid;gap:var(--beacon-system-space-micro-normal, var(--beacon-unit-atomic))}.current{padding-block:var(--beacon-system-space-cell-free-floating, var(--beacon-cell-space-padding))}.current :is(h1,h2,h3,h4,h5,h6),.current ::slotted(*){--heritage-text-color: var(--beacon-color-text-default-on-light);font:var(--beacon-system-font-weight-bold, var(--beacon-font-weight-bold)) var(--beacon-system-font-size-serif-headline-50, var(--beacon-headline-font-size-50)/var(--beacon-headline-font-line-height-module-50) var(--beacon-font-family-default));color:var(--beacon-system-color-text-title, var(--heritage-text-color));margin:0}a,::slotted(a){--beacon-color-hyperlink-default: var(--beacon-color-hyperlink-default-on-light)}@media (min-width: 960px){.current :is(h1,h2,h3,h4,h5,h6),.current ::slotted(*){--heritage-text-color: var(--beacon-popover-color-text)}a,::slotted(a){color:var(--beacon-system-color-text-link, var(--beacon-color-hyperlink-reversed))}}\n"])));
var w = Object.defineProperty,
  A = Object.getOwnPropertyDescriptor,
  a = function a(c, t, o, n) {
    for (var e = n > 1 ? void 0 : n ? A(t, o) : t, s = c.length - 1, i; s >= 0; s--) (i = c[s]) && (e = (n ? i(t, o, e) : i(e)) || e);
    return n && e && w(t, o, e), e;
  };
var r = /*#__PURE__*/function (_h) {
  _inherits(r, _h);
  function r() {
    var _this;
    _classCallCheck(this, r);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(r).apply(this, arguments)), _this.beaconTagName = d.beaconTagName, _this.expanded = !1, _this.setSelectedCountry = function (_ref) {
      var t = _ref.detail;
      if (!_this.selectedCountry) {
        var o = t.country.cloneNode(!0);
        _this.selectedCountry = o, _this.selectedCountry.isExpanded = !0, _this.selectedCountry.setAttribute("slot", "current-country"), _this.appendChild(_this.selectedCountry);
      }
    };
    return _this;
  }
  _createClass(r, [{
    key: "countrySelectorPrerender",
    value: function countrySelectorPrerender() {
      this.addEventListener(b.NAV_LANGUAGE_SELECT, this.setSelectedCountry);
    }
  }, {
    key: "updateAnalytics",
    value: function updateAnalytics() {
      _get(_getPrototypeOf(r.prototype), "updateAnalytics", this).call(this), this.metricsSection = f.level2LangSelector;
    }
  }, {
    key: "render",
    value: function render() {
      return u(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      <div class=\"current-selection\">\n        <div class=\"current\">\n          <slot name=\"title\"><h3>Current selection</h3></slot>\n        </div>\n        <slot name=\"current-country\"></slot>\n      </div>\n      <slot class=\"regions\"></slot>\n    "])));
    }
  }], [{
    key: "styles",
    get: function get() {
      return [_get(_getPrototypeOf(r), "styles", this), S];
    }
  }, {
    key: "lightDOMStyles",
    get: function get() {
      return [_get(_getPrototypeOf(r), "lightDOMStyles", this), C];
    }
  }]);
  return r;
}(h(p, v()));
r.tagName = d.beaconTagName;
a([x({
  selector: "beacon-region-selector",
  flatten: !0
}, !0)], r.prototype, "regions", 2);
a([m({
  type: Boolean,
  reflect: !0
})], r.prototype, "expanded", 2);
a([y()], r.prototype, "selectedCountry", 2);
a([g], r.prototype, "countrySelectorPrerender", 1);
export { r as BeaconCountrySelector };